const navigateCanBeToNewTab = (event, path, navigate) => {
    if (event.ctrlKey || event.metaKey || event.altKey) {
        window.open(path, '_blank');
    } else {
        navigate(path);
    }
};

export default navigateCanBeToNewTab;
